import React, { useState, useEffect } from 'react';
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import {config} from "../../shared/config";
import * as util from '../../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import Laoding from '../../shared/Laoding';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import NumberBox from '../../shared/NumberBox';

export default function TaxServiceParams(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [range, setRange] = useState([]);
    const maxItems = 15;

    useEffect(() => {
        var params = {
            login:util.getLoginDto(), 
            ownerType:util.OwnerTypes.System, 
            ownerId:"", 
            names:[util.ParameterTypes.BillNumberPriceRangeForTaxService], 
        };
        var url = config.Server+`/basic/setting/parameters/get`;
        var rng = [            
        ];
        var from = 1;
        for(var i=0;i<maxItems;i++){
            rng.push({from:from, to:0, price:0});
            from = 0;
        }
        setLoading(true);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            setLoading(false);
            if(response.state === "ok"){
                response = response.data;
                for(var i=0;i<response.length;i++){
                    if(response[i].name == util.ParameterTypes.BillNumberPriceRangeForTaxService){
                        var sa = response[i].value.split(",");
                        from = 1;
                        var to  = 0;
                        var price = 0;
                        for(var j=0;j<sa.length;j++){
                            var ii = sa[j].split(":");
                            to = parseInt(ii[0]);
                            price = parseInt(ii[1]);
                            console.log("")
                            rng[j].from = from;
                            rng[j].to = to;
                            rng[j].price = price;
                            from = to + 1;
                        }
                    }
                }
                setRange(rng);
                console.log("rng is>", rng);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setLoading(false);
                setRange(rng);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setLoading(false);
            setRange(rng);
        });
    }, []);
    const onInputChanged = function(val, ind, name){
        if(ind == -1) {}
        else{
            var rng = [...range];
            rng[ind][name] = val;
            if((name == "to")&&(ind <(maxItems-1)))rng[ind+1].from = val + 1;
            setRange(rng);
        }
    }
    const checkDataEntry = function(){
        return true;
    }
    const saveItem = function(){
        if (!checkDataEntry()) return;
        var rng = String(range[0].to) + ":" + "0";
        for(var i=1;i<maxItems;i++){
            if(range[i].to > 0){
                rng += "," + String(range[i].to) + ":" + String(range[i].price);
            }
        }
        
        var params = {
            login: util.getLoginDto(), 
            ownerType: util.OwnerTypes.System,
            ownerId:"",
            parameters:[
                {name:util.ParameterTypes.BillNumberPriceRangeForTaxService, value:rng}
            ]
        };
        setSaving(true);
        var url = config.Server + `/basic/setting/parameters/save`;
        axios
        .post(url, params)
        .then(res => {
            var response = res.data;
            if (response.state === "ok") {
                setErrorMessage("با موفقیت ثبت گردید");
                setErorVisible(true);
                setSaving(false);
                //setRedirectUrl("/home")
            }
            else {
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });
    }

    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :loading?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت پارامترها..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            <div style={{textAlign:"center", padding:"5px", backgroundColor:"#ccc", marginTop:"10px", borderTopRightRadius:"5px", borderTopLeftRadius:"5px"}}>
                تنظیم پارامترهای قیمت برای سامانه مودیان مالیاتی
            </div>
            
            <table style={{width:"350px", margin:"0px auto"}}>
                <tbody>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                        <td colSpan={3} style={{textAlign:"center"}}>تنطیم مبالغ به ازای تعداد صورتحساب در سال</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", width:"100px", borderRight:"0px"}}>&nbsp;</td>
                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", width:"80px"}}>صورتحساب در سال</td>
                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", width:"130px", borderLeft:"0px"}}>مبلغ</td>
                        <td>&nbsp;</td>
                    </tr>
                    {
                        range.map((r, rInd)=>{
                            return(
                                <tr>
                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>از &nbsp;&nbsp;{r.from}&nbsp;&nbsp;تا&nbsp;&nbsp;</td>
                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0"}}>
                                        <NumberBox seperate={true} value={r.to} onChange ={(val) => {onInputChanged(val, rInd, "to")}} width={70} />
                                    </td>
                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                        {
                                            rInd == 0?<>0</>:
                                            <NumberBox seperate={true} value={r.price} onChange ={(val) => {onInputChanged(val, rInd, "price")}} width={120} />
                                        }
                                        
                                    </td>
                                    <td>&nbsp;</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table> 
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}}>                
                <Col className="d-flex justify-content-center align-items-center" style={{marginBottom:"150px"}}>
                    <Button severity="success" onClick={()=>{saveItem()}} style={{borderRadius:"5px"}} loading={saving} iconPos="right" icon="pi pi-check">&nbsp;&nbsp;ثبت پارامترها&nbsp;&nbsp;</Button>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}